import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Importar traducciones compartidas
import commonES from '@/shared/locales/es/common.json';
import commonEN from '@/shared/locales/en/common.json';
import commonHT from '@/shared/locales/ht/common.json';
import commonFR from '@/shared/locales/fr/common.json';

// Importar traducciones del componente actualizarPerfil
import actualizarPerfilES from '@/shared/components/ActualizarPerfilModal/locales/es/actualizarPerfil.json';
import actualizarPerfilEN from '@/shared/components/ActualizarPerfilModal/locales/en/actualizarPerfil.json';
import actualizarPerfilHT from '@/shared/components/ActualizarPerfilModal/locales/ht/actualizarPerfil.json';
import actualizarPerfilFR from '@/shared/components/ActualizarPerfilModal/locales/fr/actualizarPerfil.json';

// Importar traducciones del módulo calendar
import calendarES from '@/modules/calendar/locales/es/calendar.json';
import calendarEN from '@/modules/calendar/locales/en/calendar.json';
import calendarHT from '@/modules/calendar/locales/ht/calendar.json';
import calendarFR from '@/modules/calendar/locales/fr/calendar.json';

// Importar traducciones del módulo archivo
import archivoES from '@/modules/Archivo/locales/es/archivo.json';
import archivoEN from '@/modules/Archivo/locales/en/archivo.json';
import archivoHT from '@/modules/Archivo/locales/ht/archivo.json';
import archivoFR from '@/modules/Archivo/locales/fr/archivo.json';

// Importar traducciones de DocumentosPersonales
import documentosPersonalesES from '@/shared/components/ConfiguracionPerfil/DocumentosPersonales/locales/es/documentosPersonales.json';
import documentosPersonalesEN from '@/shared/components/ConfiguracionPerfil/DocumentosPersonales/locales/en/documentosPersonales.json';
import documentosPersonalesHT from '@/shared/components/ConfiguracionPerfil/DocumentosPersonales/locales/ht/documentosPersonales.json';
import documentosPersonalesFR from '@/shared/components/ConfiguracionPerfil/DocumentosPersonales/locales/fr/documentosPersonales.json';

const resources = {
  es: {
    common: commonES,
    calendar: calendarES,
    archivo: archivoES,
    actualizarPerfil: actualizarPerfilES,
    documentosPersonales: documentosPersonalesES,
  },
  en: {
    common: commonEN,
    calendar: calendarEN,
    archivo: archivoEN,
    actualizarPerfil: actualizarPerfilEN,
    documentosPersonales: documentosPersonalesEN,
  },
  ht: {
    common: commonHT,
    calendar: calendarHT,
    archivo: archivoHT,
    actualizarPerfil: actualizarPerfilHT,
    documentosPersonales: documentosPersonalesHT,
  },
  fr: {
    common: commonFR,
    calendar: calendarFR,
    archivo: archivoFR,
    actualizarPerfil: actualizarPerfilFR,
    documentosPersonales: documentosPersonalesFR,
  },
};

if (i18n.isInitialized) {
  // HMR: i18n ya está inicializado — actualizar recursos sin reinicializar
  for (const [lang, namespaces] of Object.entries(resources)) {
    for (const [ns, bundle] of Object.entries(namespaces)) {
      i18n.addResourceBundle(lang, ns, bundle, true, true);
    }
  }
} else {
  i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      resources,
      fallbackLng: 'es',
      supportedLngs: ['es', 'en', 'ht', 'fr'],
      defaultNS: 'common',
      detection: {
        order: ['localStorage', 'navigator'],
        caches: ['localStorage'],
        lookupLocalStorage: 'i18nextLng',
      },
      interpolation: {
        escapeValue: false,
      },
      debug: import.meta.env.DEV,
      react: {
        useSuspense: false,
      },
    });
}

export default i18n;
